"use strict";

import http from "@/http";

const BASE_NAME = "/email-deliveries";

const list = async () => (await http.get(BASE_NAME)).data;
const create = async delivery => (await http.post(BASE_NAME, delivery)).data;
const edit = async (id, delivery) => (await http.put(`${BASE_NAME}/${id}`, delivery)).data;
const remove = async id => { await http.delete(`${BASE_NAME}/${id}`); };
const sendTest = async (id, toEmail, contractorCompany, asXlsx) =>
  (await http.post(`${BASE_NAME}/${id}/test`, { toEmail, contractorCompany, asXlsx })).data;
const eligibleContractors = async id =>
  (await http.get(`${BASE_NAME}/${id}/contractors`)).data;

export default { list, create, edit, remove, sendTest, eligibleContractors };
